var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightsLayerClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.449951,
    width: 29.5,
    height: 26.7,
    rx: 5.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.449951,
    width: 29.5,
    height: 26.7,
    rx: 5.75,
    stroke: "#6E7079",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3673_1381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 17,
    height: 17
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.17383,
    y: 5.74756,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3673_1381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8407 20.4141V18.7475L13.8407 17.3475V14.9475L8.50732 17.0808V15.0808L13.8407 11.3475V8.41414C13.8407 8.04748 13.9712 7.73359 14.2323 7.47248C14.4934 7.21137 14.8073 7.08081 15.174 7.08081C15.5407 7.08081 15.8545 7.21137 16.1157 7.47248C16.3768 7.73359 16.5073 8.04748 16.5073 8.41414V11.3475L21.8407 15.0808V17.0808L16.5073 14.9475V17.3475L18.5073 18.7475V20.4141L15.174 19.4141L11.8407 20.4141Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightsLayerClose);
export default __webpack_public_path__ + "static/media/flightsLayerClose.cd44a4223d273d8229d8734bc154945e.svg";
export { ForwardRef as ReactComponent };